import { userKeys } from "./wd_app_config.js";

export function getUserAvatar(portraitId) {
  var imageUrl = require("@/assets/common/icon_user_avatar_default.png");
  var imageHubUrl = localStorage.getItem(userKeys.key_serviceUrl_ImageHub);
  if (
    portraitId != null &&
    portraitId !== "" &&
    portraitId !== "00000000000000000000000000000000"
  ) {
    imageUrl =
      imageHubUrl + "/dir/" + getImageHubName(portraitId, 3, 96, 96, "png");
  }
  return imageUrl;
}

export function getCurrentUserAvatar() {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  return getUserAvatar(user.PortraitId);
}

export function getImageHubName(imageId, scaleType, width, height, extension) {
  imageId = imageId.replace("/-/g", "");
  var result = "";
  result = result.concat(
    imageId,
    "_",
    scaleType,
    "_",
    width,
    "_",
    height,
    ".",
    extension
  );
  return result;
}
